var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgGoogleplay = function SvgGoogleplay(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 139,
    height: 40,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M133.246 40H5.216c-2.815 0-5.12-2.251-5.12-5V5c0-2.749 2.305-5 5.12-5h128.03c2.815 0 5.121 2.251 5.121 5v30c0 2.749-2.306 5-5.121 5Z",
    fill: "#000"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M133.246.801c2.371 0 4.3 1.884 4.3 4.199v30c0 2.315-1.929 4.199-4.3 4.199H5.216c-2.37 0-4.3-1.884-4.3-4.199V5c0-2.315 1.93-4.199 4.3-4.199h128.03Zm0-.801H5.216C2.402 0 .097 2.251.097 5v30c0 2.749 2.305 5 5.12 5h128.03c2.815 0 5.121-2.251 5.121-5V5c0-2.749-2.306-5-5.121-5Z",
    fill: "#A6A6A6"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M48.662 10.244c0 .835-.256 1.503-.76 2.002-.58.591-1.336.889-2.261.889-.885 0-1.64-.303-2.26-.899-.621-.605-.93-1.347-.93-2.236 0-.889.309-1.631.93-2.231.62-.602 1.375-.904 2.26-.904.44 0 .86.089 1.26.254.4.166.725.39.961.668l-.535.528c-.411-.474-.97-.708-1.686-.708-.646 0-1.205.22-1.68.664-.47.445-.706 1.021-.706 1.729 0 .707.236 1.289.706 1.734a2.399 2.399 0 0 0 1.68.663c.685 0 1.26-.225 1.715-.668.3-.294.47-.7.515-1.217h-2.23V9.79h2.975c.036.156.046.307.046.454ZM53.383 7.739h-2.795v1.9h2.52v.722h-2.52v1.9h2.795v.737h-3.586V7.002h3.586v.737ZM56.714 12.998h-.792v-5.26h-1.714v-.736h4.221v.737h-1.715v5.259ZM61.483 12.998V7.002h.79v5.996h-.79ZM65.776 12.998h-.785v-5.26h-1.72v-.736h4.226v.737h-1.721v5.259ZM75.488 12.226c-.606.606-1.356.909-2.25.909-.9 0-1.651-.303-2.257-.909-.604-.605-.905-1.347-.905-2.226s.301-1.621.905-2.226c.606-.607 1.356-.909 2.256-.909.89 0 1.64.302 2.246.914.61.61.91 1.347.91 2.221 0 .879-.3 1.621-.905 2.226Zm-3.922-.502c.456.448 1.01.674 1.671.674.656 0 1.215-.226 1.666-.674.454-.449.685-1.025.685-1.724 0-.699-.23-1.275-.685-1.724-.45-.449-1.01-.674-1.666-.674-.66 0-1.215.225-1.67.674-.455.449-.685 1.025-.685 1.724 0 .699.23 1.275.684 1.724ZM77.504 12.998V7.002h.96l2.986 4.663h.034l-.034-1.152v-3.51h.79v5.995h-.825L78.29 8.105h-.035l.035 1.157v3.736h-.785Z",
    fill: "#fff",
    stroke: "#fff",
    strokeWidth: 0.16,
    strokeMiterlimit: 10
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M69.881 21.753c-2.405 0-4.37 1.787-4.37 4.253 0 2.447 1.965 4.253 4.37 4.253 2.411 0 4.376-1.806 4.376-4.253 0-2.466-1.965-4.253-4.376-4.253Zm0 6.83c-1.32 0-2.455-1.063-2.455-2.577 0-1.534 1.135-2.579 2.455-2.579s2.461 1.046 2.461 2.58c0 1.513-1.14 2.577-2.46 2.577Zm-9.537-6.83c-2.41 0-4.37 1.787-4.37 4.253 0 2.447 1.96 4.253 4.37 4.253s4.372-1.806 4.372-4.253c0-2.466-1.962-4.253-4.371-4.253Zm0 6.83c-1.32 0-2.46-1.063-2.46-2.577 0-1.534 1.14-2.579 2.46-2.579s2.456 1.046 2.456 2.58c0 1.513-1.136 2.577-2.456 2.577Zm-11.348-5.527v1.808h4.42c-.128 1.01-.474 1.752-1.004 2.27-.645.625-1.65 1.319-3.416 1.319-2.72 0-4.85-2.144-4.85-4.8 0-2.657 2.13-4.8 4.85-4.8 1.471 0 2.541.56 3.331 1.288l1.305-1.273c-1.105-1.03-2.575-1.822-4.636-1.822-3.73 0-6.866 2.964-6.866 6.607 0 3.642 3.135 6.606 6.866 6.606 2.017 0 3.531-.645 4.722-1.855 1.22-1.192 1.6-2.866 1.6-4.219 0-.42-.036-.806-.1-1.129h-6.222Zm46.405 1.401c-.36-.95-1.47-2.704-3.73-2.704-2.24 0-4.106 1.723-4.106 4.253 0 2.383 1.846 4.253 4.32 4.253a4.343 4.343 0 0 0 3.632-1.885l-1.486-.966c-.495.707-1.17 1.176-2.145 1.176-.97 0-1.665-.434-2.11-1.289l5.826-2.354-.2-.483Zm-5.94 1.417a2.359 2.359 0 0 1 2.275-2.48c.76 0 1.406.371 1.62.902l-3.895 1.578ZM84.725 30h1.915V17.5h-1.915V30Zm-3.137-7.3h-.064c-.43-.497-1.25-.947-2.29-.947-2.182 0-4.176 1.87-4.176 4.267 0 2.384 1.994 4.239 4.176 4.239 1.04 0 1.86-.454 2.29-.966h.064v.61c0 1.626-.89 2.5-2.325 2.5-1.17 0-1.896-.825-2.195-1.52l-1.666.68c.48 1.127 1.751 2.515 3.861 2.515 2.246 0 4.14-1.29 4.14-4.43v-7.637h-1.815v.689Zm-2.19 5.884c-1.32 0-2.425-1.079-2.425-2.564 0-1.499 1.105-2.593 2.425-2.593 1.3 0 2.326 1.094 2.326 2.593 0 1.485-1.025 2.564-2.326 2.564ZM104.369 17.5h-4.581V30h1.91v-4.736h2.671c2.121 0 4.201-1.499 4.201-3.883 0-2.382-2.085-3.881-4.201-3.881Zm.049 6.025h-2.72v-4.286h2.72a2.195 2.195 0 0 1 2.241 2.142c0 .968-.814 2.144-2.241 2.144Zm11.809-1.796c-1.381 0-2.816.595-3.406 1.913l1.695.694c.365-.694 1.036-.918 1.745-.918.991 0 1.996.58 2.011 1.607v.131c-.345-.195-1.085-.483-1.995-.483-1.826 0-3.686.98-3.686 2.812 0 1.675 1.495 2.754 3.176 2.754 1.285 0 1.995-.567 2.44-1.225h.065v.966h1.845v-4.795c0-2.216-1.695-3.456-3.89-3.456Zm-.231 6.85c-.625 0-1.495-.303-1.495-1.059 0-.968 1.085-1.339 2.025-1.339.841 0 1.236.181 1.746.42-.149 1.158-1.17 1.978-2.276 1.978Zm10.843-6.576-2.196 5.418h-.065l-2.27-5.418h-2.06l3.411 7.572-1.946 4.214h1.996l5.255-11.787h-2.125ZM109.62 30h1.916V17.5h-1.916V30Z",
    fill: "#fff"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M10.783 7.539c-.301.307-.475.786-.475 1.406V31.06c0 .62.174 1.099.475 1.406l.074.068L23.55 20.146v-.292L10.857 7.466l-.074.073Z",
    fill: "url(#googleplay_svg__a)"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "m27.776 24.277-4.226-4.13v-.293l4.231-4.132.095.054 5.011 2.784c1.43.79 1.43 2.09 0 2.885l-5.011 2.779-.1.053Z",
    fill: "url(#googleplay_svg__b)"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M27.876 24.224 23.55 20 10.783 32.466c.475.488 1.25.547 2.13.059l14.963-8.301",
    fill: "url(#googleplay_svg__c)"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M27.876 15.776 12.914 7.475c-.881-.482-1.656-.424-2.13.064L23.55 20l4.326-4.224Z",
    fill: "url(#googleplay_svg__d)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "googleplay_svg__a",
    x1: 22.423,
    y1: 31.29,
    x2: 5.645,
    y2: 14.106,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00A0FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.007,
    stopColor: "#00A1FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.26,
    stopColor: "#00BEFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.512,
    stopColor: "#00D2FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.76,
    stopColor: "#00DFFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#00E3FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "googleplay_svg__b",
    x1: 34.749,
    y1: 19.998,
    x2: 9.966,
    y2: 19.998,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFE000"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.409,
    stopColor: "#FFBD00"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.775,
    stopColor: "orange"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF9C00"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "googleplay_svg__c",
    x1: 25.524,
    y1: 17.704,
    x2: 2.772,
    y2: -5.599,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF3A44"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C31162"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "googleplay_svg__d",
    x1: 7.569,
    y1: 39.824,
    x2: 17.729,
    y2: 29.418,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#32A071"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.069,
    stopColor: "#2DA771"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.476,
    stopColor: "#15CF74"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.801,
    stopColor: "#06E775"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#00F076"
  })))));
};
export default SvgGoogleplay;